// extracted by mini-css-extract-plugin
module.exports = {"main":"Organizer_main__2pX5s","name":"Organizer_name__VcHTO","logo":"Organizer_logo__6JPSG"};